export default "__VITE_ASSET__ZxMYMk_S__"